// Komponenten <eui-pop-up-meny>:



//import ssoTestkomponent from 'v-components/ssoTestkomponent';





import Vue from 'vue';

import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';

import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';
import throttla from 'lodash.throttle';
import debounce from 'lodash.debounce';

// https://linusborg.github.io/portal-vue/#/guide
//import PortalVue from 'portal-vue';
import { Portal, PortalTarget } from 'portal-vue';
import euiModifieradSvg from 'v-components/euiModifieradSvg';
////import AllaSvgikoner from 'Svgikoner';

//import euiMaintainDisabled from 'v-directives/euiMaintainDisabled';
import euiMaintainTabFocus from 'v-directives/euiMaintainTabFocus';
import allyQuery from 'ally.js/src/query/_query';
import { ssoTooltips } from 'ssoTooltips';

// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
let uniktIdCounter = 0;


//###################################################################################################

export default {

	name: 'eui-pop-up-meny',

	// :to="portalTargetName"
	template: `
		<!--	v-if="visaMenyn"-->
		<portal :name="portalName" :target-el="'#' + this.portalTargetName"			v-if="visaMenyn"
			v-on="$listeners"
		>
			<!-- Måste vara ett "*single* root element"!
			NJET, inte när denna *inte* är "slim" längre, väl? -->

			<!-- tabindex="0" nedan är för att annars går det inte att fånga tangentbords-events (då man inte är i en input control): -->
			<!--:class="{ '-visas':visaMenyn }"-->
			<!--	v-show="visaMenyn"-->
			<!-- Behövs inte. Hanteras på generellt tangenttrycksätt ist:	@keydown.esc="visaMenyn = false"-->
			<!--	v-eui-maintain-disabled="{ disabled: visaMenyn, wholeDocumentExceptThisElement: true }" -->
			<!-- tabindex="0" -->
			<div
				ref="menyn"
				:id="uniktId"
				class="_eui-pop-up-meny"
				:class="{
					'-visas':visaMenyn && arSlutpositionerad,
					'-fading-out':doljMenynLangsamt,
					'-inaktiverad':skaVaraInaktiverad,
					'-osynlig':skaVaraOsynlig,
					'-undermeny':vpPlacering === 'h',

				}"
				:disabled="skaVaraInaktiverad"
				:style="{
					left: this.menynsDimOchPos.x + 'px',
					top: this.menynsDimOchPos.y + 'px',
					width: this.menynsDimOchPos.width,
					height: this.menynsDimOchPos.height
				}"

				v-eui-maintain-tab-focus="visaMenyn && arAktiverad"

				@mouseover="mouseIsOverMeny = true;"
				@mouseleave="mouseIsOverMeny = false;"
			>

				<slot name="pop-up-menyhuvud"></slot>

				<ul ref="menyalternativContainer">

					<template v-for="(del, menydelIndex) in menyConfig.menydelar">


						<!-- ##### Alternativ (event eller länk): #########################################-->

						<!--	@mouseover="onStangAllaUndermenyerEfterFordrojning(_self, menydelIndex)"-->
						<li v-if="del.arAvTypEventEllerLank" :key="menydelIndex"
							:menydel-index="menydelIndex"
							:tabindex="(!del.disabled && !del.checked ? 0 : -1)"
							:disabled="del.disabled"
							:title="!del.disabled && del.tooltip"
							class="_eui-pop-up-meny_alternativ"
							:class="del.cssModifierClass"
							:style="{
								'pointer-events': del.checked && 'none',
							}"

							@click.stop="!del.checked && onMenyalternativValt(menydelIndex)"
							@keydown.enter.stop="!del.checked && onMenyalternativValt(menydelIndex)"
							@keydown.space.stop="!del.checked && onMenyalternativValt(menydelIndex)"

							@mouseover="!del.checked && onMouseOverMenyalternativ(menydelIndex)"
							@mouseleave="!del.checked && onMouseLeaveMenyalternativ(menydelIndex)"
						>
							<span
								class="_eui-pop-up-meny_ikoncontainer"
							>

								<eui-modifierad-svg v-if="del.checked"
									vp-ikon="bock"
									style="
										stroke: #419C41;
										stroke-width: 2;
										height: 1.2em;
										width: 1.2em;
									"
								></eui-modifierad-svg>

								<eui-modifierad-svg v-if="!del.checked && del.ikon"
									:vp-ikon="del.ikon"
									style="
										height: 1.2em;
										width: 1.2em;
									"
								></eui-modifierad-svg>

							</span>

							<span
								class="_eui-pop-up-meny_alt-text"
								v-html="del.text"
							></span>

							<span
								class="_eui-pop-up-meny_undermeny-ikoncontainer"
							></span>

						</li>

						<div v-if="del.disabled && del.tooltip"
							class="_eui-pop-up-meny_alternativ-overlay-with-tooltip"
							:title="del.tooltip"
						></div>


						<!-- ##### Alternativ med undermeny: #########################################-->

						<li v-if="del.arAvTypUndermeny" :key="menydelIndex"
							:menydel-index="menydelIndex"
							:tabindex="(!del.disabled ? 0 : -1)"
							:disabled="del.disabled"
							:title="!del.disabled && del.tooltip"
							class="_eui-pop-up-meny_alternativ"
							:class="del.cssModifierClass"

							@keydown.enter.stop="oppnaUndermeny(menydelIndex)"
							@keydown.space.stop="oppnaUndermeny(menydelIndex)"
							@keydown.right.stop="oppnaUndermeny(menydelIndex)"

							@mouseover="onMouseOverMenyalternativ(menydelIndex)"
							@mouseleave="onMouseLeaveMenyalternativ(menydelIndex)"
						>
							<span
								class="_eui-pop-up-meny_ikoncontainer"
							>
								<!--	:vp-svg-markup="allaSvgikoner[del.ikon]"-->
								<eui-modifierad-svg v-if="del.ikon"
									:vp-ikon="del.ikon"
									style="
										height: 1.2em;
										width: 1.2em;
									"
								></eui-modifierad-svg>
							</span>

							<span
								class="_eui-pop-up-meny_alt-text"
								v-html="del.text"
							></span>

							<span
								class="_eui-pop-up-meny_undermeny-ikoncontainer"
							>
								<eui-modifierad-svg
									vp-ikon="undermenyPil"
									style="
										height: .65em;
										width: .65em;
										stroke-width: 0;
										fill: currentColor;
										transform: rotate(90deg);
									"
								></eui-modifierad-svg>
							</span>

						</li>

						<div v-if="del.disabled && del.tooltip"
							class="_eui-pop-up-meny_alternativ-overlay-with-tooltip"
							:title="del.tooltip"
						></div>

						<!-- ####### Själva undermenyn: -->

						<!-- .sync nedan gör att denna komponent lyssnar på eventet 'update:vpVisaMenyn' och då ändrar värdet på visaMermenyn: -->
						<eui-pop-up-meny v-if="del.arAvTypUndermeny && del.visaUndermenyn"
							:ref="'undermeny-till-' + menydelIndex"
							:vp-ar-undermeny="true"
							:vp-meny-stack="$root.popUpMenyStack"
							:vp-meny-config.sync="del.undermenyConfig"
							:vp-visa-menyn.sync="del.visaUndermenyn"
							:vp-vid-element-query-selector="'#' + uniktId + ' [menydel-index=' + String.fromCharCode(34) + menydelIndex + String.fromCharCode(34) + ']'"
							vp-placering="h"
							@menyalternativ-valt-i-pop-up-meny="onMenyalternativValtIUndermeny"
						>
							<template #pop-up-menyhuvud>
								<slot name="menyhuvud"></slot>
							</template>

						</eui-pop-up-meny>






						<!-- ##### Linje: #########################################-->

						<div v-if="del.arAvTypLinje" :key="menydelIndex"
							:menydel-index="menydelIndex"
							class="_eui-pop-up-meny_linje"
						></div>


						<!-- ##### Komponent: #########################################-->

						<component v-if="del.arAvTypKomponent" :key="menydelIndex"
							:is="del.komponentnamn"
							:menydel-index="menydelIndex"
							v-bind="del.komponentProps"
							class="_eui-pop-up-meny_komponent"
						></component>

					</template>

				</ul>
			</div>
		</portal>
	`,

	components: {
		Portal,
		PortalTarget,
		[euiModifieradSvg.name]: euiModifieradSvg,

		//ssoTestkomponent,
	},

	mixins: [ euiLifecycleStatusesMixin ],

	directives: {
		[euiMaintainTabFocus.name]: euiMaintainTabFocus,
	},

	props: {
		vpMenyId: {
			type: String,
			default: null,
		},

		// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpMenyStack':
		vpMenyStack: {
			type: Array,
			required: true,
		},

		// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpMenyConfig':
		vpMenyConfig: {
			type: [euiPopUpMenyClasses.menyConfig, Object],
			required: true,
		},

		vpArUndermeny: {
			type: Boolean,
			default: false
		},

		vpVidElementQuerySelector: {
			type: String,
			required: true
		},

		vpPlacering: {
			type: String,
			default: 'u',		// u = under, h = höger
		},

		vpStangInteVidKlickTouchPaVidElementet: {
			type: Boolean,
			default: true
		},

		// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpVisaMenyn':
		vpVisaMenyn: {
			type: Boolean,
			default: false
		},

		// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpDoljMenynLangsamt':
		vpDoljMenynLangsamt: {
			type: Boolean,
			default: false
		},

		vpInaktiverad: {
			type: Boolean,
			default: false
		},
		vpOsynlig: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			// Reaktiva data:

			menyConfig: this.vpMenyConfig,

			visaMenyn: false,
			doljMenynLangsamt: false,

			arAktiverad: false,		// Aktiverad för begränsad tab-sekvens, events etc. *Inte* === visas (men den kan bara vara aktiv om den visas)!

			menynsDimOchPos: { x: 0, y: 0, width: '', height: '' },
			arSlutpositionerad: false,

			// Obs! Endast för läsning, typ! Ändring sker alltid genom events till $root (där denna array finns):
			menyStack: this.vpMenyStack,		// Arrays are reference types in JavaScript. *MEN* det funkar inte riktigt så i Vue!!

			mouseIsOverMeny: false,
			mouseIsOverMenydelIndex: undefined,

			// Obs! Nedan: inte reaktiva (read-only) data, medelst användningen av Object.freeze():

			uniktIdNr: Object.freeze(++uniktIdCounter),
			uniktId: Object.freeze('eui-pop-up-meny-unikt-' + uniktIdCounter),
			portalName: Object.freeze('portal_eui-pop-up-meny-' + uniktIdCounter),
			portalTargetName: Object.freeze('portal-target_eui-pop-up-meny-' + uniktIdCounter),

			vidElement: undefined,		// Object.freeze() sker vid tilldelning!
		};
	},

	computed: {
		menyId() {
			return this.vpMenyId || ('meny-' + this.uniktIdNr);
		},

		antalMenyerPaStacken() {
			return (!this.menyStack ? 0 : this.menyStack.length);
		},

		overstaMenynIdNr() {
			return (this.antalMenyerPaStacken === 0 ? null : this.menyStack[this.antalMenyerPaStacken - 1]);
		},

		arOverstaMenyn() {
			return this.uniktIdNr === this.overstaMenynIdNr;
		},


		skaVaraOsynlig() {
			return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedAndNextTickHasOccured);	//AndSecondNextTickHasOccured);
		},

		skaVaraInaktiverad() {
			return (this.vpInaktiverad);				// || !this.lifecycleStatuses.mixinMountedAndSecondNextTickHasOccured);
		},
	},

	watch: {
		vpVisaMenyn(nyttVarde, tidigareVarde) {
			// Obs! Denna watch triggar *inte* vid initial rendering med värdet true!
			//console.log('watch:vpVisaMenyn', tidigareVarde + ' –> ' + nyttVarde, `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			this.visaMenyn = nyttVarde;
		},

		visaMenyn(nyttVarde, tidigareVarde) {
			// Obs! Denna watch triggar *inte* vid initial rendering med värdet true!
			//console.log('watch:visaMenyn', tidigareVarde + ' –> ' + nyttVarde, `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			if (nyttVarde === true)
			{
				// NU ska den visas:
				this.laggTillOverstPaMenystacken();

				if (!this.arSlutpositionerad)
				{
					this.sattMenynsDimOchPos();

					// För att elementet ska hinna visas:
					this.$nextTick(function () {
						this.positioneraOmMenynOmDenOverflowarBody();
					});
				}
			}
			else
			{
				// NU ska den döljas:

				this.arSlutpositionerad = false;		// För säkerhets skull :/

				// Edit: watch:visaMenyen *och inte heller* watch:vpVisaMenyn hinner aldrig triggas när en undermenys visning sätts = false. Då destroyas den direkt. Detta skiljer sig från dialog-komponenten och anledningen är att de båsa har olika v-if-konstruktioner. Här flyttar vi därför detta till beforeDestroy():
				//// Skicka detta event *här*, för inte säkert att det kan skickas senare i reaktivitetssekvensen om hela komponenten hinner detroyas innan (hade nog också kunnat ligga i beforeDestroy()?):
				//// Därför har också detta event namnet "..stangs" och inte "..stangd", men när det emittas så är det oåterkalleligt så att menyn kommer att vara stängd inom båkdelar av en sekund:
				//this.$emit('menyn-stangs', this.menyId);	// Egensatt Id (via prop) eller auto uppbyggt med uniktIdNr.

				//this.taBortFranMenystacken();
			}
		},

		vpDoljMenynLangsamt(nyttVarde, tidigareVarde) {
			// Obs! Denna watch triggar *inte* vid initial rendering med värdet true!
			this.doljMenynLangsamt = nyttVarde;

			if (nyttVarde)
			{
				// Denna för att garanterat dölja *och* avbryta ev redan triggad visning av tooltip:
				// Kan göras så här för i efterföljande destroyed() så ominitieras tooltipsen för sidan:
				ssoTooltips.destroyaAlla();

				// Efter en kort stund (> än dölj-animeringen i css!) ska användare-menyn stängas helt:
				setTimeout(() => {
						// 'this' = anroparens kontext.
						this.doljMenynLangsamt = false;
					}
					, 500	// ms
				);
			}
		},

		doljMenynLangsamt(nyttVarde, tidigareVarde) {
			// Obs! Denna watch triggar *inte* vid initial rendering med värdet true!

			// Propen används med .sync i parent component:
			this.$emit('update:vpDoljMenynLangsamt', nyttVarde);

			if (!nyttVarde)
			{
				// Om ändrad från true –> false:
				// Stäng därefter menyn:
				this.inaktiveraOchStangDenOppnadeMenyn();	// = Avbryt
			}
		},

		vpMenyConfig: {
			// Obs! Denna watch är "deep"!
			handler(nyttVarde, tidigareVarde)
			{
				//console.log('watch:vpMenyConfig', tidigareVarde + ' –> ' + nyttVarde, `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

				this.menyConfig = nyttVarde;
			},
			deep: true,
		},

		menyConfig: {
			// Obs! Denna watch är "deep"!
			handler(nyttVarde, tidigareVarde)
			{
				//console.log('watch:menyConfig', tidigareVarde + ' –> ' + nyttVarde, `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

				// Propen används med .sync i parent component:
				this.$emit('update:vpMenyConfig', nyttVarde);
			},
			deep: true,
		},

		mouseIsOverMenydelIndex(nyttVarde, tidigareVarde) {
			//console.log('watch:mouseIsOverMenydelIndex', tidigareVarde + ' –> ' + nyttVarde, `[${this.uniktIdNr}]`);

		},

		vpMenyStack(nyttVarde, tidigareVarde) {
			// Obs! Denna watch triggas *inte* vid initial rendering med värdet true!
			//console.log('watch:vpMenyStack', tidigareVarde + ' –> ' + nyttVarde, `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Behövs inte (Arrays are reference types in JavaScript):
			// Jo, *behövs*!
			this.menyStack = nyttVarde;

			// Aktivera/inaktivera *denna* meny beroende på plats i stacken:
			if (this.arOverstaMenyn)
			{
				// Om den här menyn *nu* är den översta:
				//console.log('   +---> "this" är nu överst: aktivera.', `[${this.uniktIdNr}]`);
				this.aktiveraMenyn();
			}
			else
			{
				// Annars: om den nu *inte* är den översta:
				//console.log('   +---> "this" är *inte* längre överst: inaktivera.', `[${this.uniktIdNr}]`);
				this.inaktiveraMenynOmDenArAktiverad();
			}
		},


	},

	methods: {
		laggTillOverstPaMenystacken() {
			//console.log('laggTillOverstPaMenystacken', `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Sätt även rätt z-index på *portal-target*, så att den speglar menyns (kommande) plats på stacken:
			// Sätts till > 1 för att hamna över eventuella injekterade saker i "parallella lager" (= "lagret under"), ex LastPass lösenordshanterare, index: 2:
			let el = document.getElementById(this.portalTargetName);
			el.style.zIndex = this.antalMenyerPaStacken + 101;		// 101-n

			// Själva ändringen av stacken måste ske på "rotnivån", för concurrency:
			this.$root.$emit('lagg-till-overst-pa-menystacken', this.uniktIdNr);
		},

		taBortFranMenystacken() {
			//console.log('taBortFranMenystacken', `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Själva ändringen av stacken måste ske på "rotnivån", för concurrency:
			this.$root.$emit('ta-bort-fran-menystacken', this.uniktIdNr);
		},

		aktiveraMenyn() {
			//console.log('aktiveraMenyn', `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			this.arAktiverad = true;

			// Flyttad: this.sattMenynsDimOchPos();

			// För att elementet ska hinna visas:
			this.$nextTick(function () {
				////console.log('# aktiveraMenyn+NextTick', `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

				// Flyttad: this.positioneraOmMenynOmDenOverflowarBody();

				// 1. Invänta att den eventuella ompositioneringen ovan reaktivt slagit igenom i DOM (men innan webbläsaren renderat om skärmen):

				// DOM not updated yet
				Vue.nextTick(function () {
						// DOM updated:
						// "nextTick allows you to do something after you have changed the data and VueJS has updated the DOM based on your data change, but before the browser has rendered those changed on the page":

						// 2: Invänta att webbläsaren även uppdaterat skärmen:

						// Grrrr!!! Nedan funkade INTE med andra testade angreppssätt: Ersatt med RÅ och OTILLFÖRLITLIG och KORKAD timeout istället:

						// Todo: Ett ännu modernare sätt, som vi nog borde anv genomgående är anonymous function med () => {}, som vad jag förstår automagiskt får "rätt" this. Testar:
						// https://www.vinta.com.br/blog/2015/javascript-lambda-and-arrow-functions:
						// "One of the major advantages of arrow functions is that it does not have it's own this value. It's this is lexically bound to the enclosing scope."
						// "Because this is lexically bound you can't change it; call() and apply() will not be able to provide another value for this."
						// (Ännu fler sätt att lösa 'this' beskrivs på https://stackoverflow.com/a/8670894/593779.)
						setTimeout(() => {
								// 'this' = anroparens kontext.

								if (this.arAktiverad)
								{
									// Om menyn *fortfarande* ska vara aktiv:
									this.startaEventLyssningForPilningOchEscIMenyn();
									this.startaEventLyssningForStangningAvMenyn();

									// Flyttat till de enskilda komponenterna för form fields:

									// Todo: Nackdel: Det blir svårt att sätta focus *igen* då menyn varit inaktiverad och sedan aktiveras igen (ex efter en meddelande-meny visats). Behöver kanske en omdesign!?

									//// Sätt autofocus om sådant attribut finns inom menyn:
									//const afEl = this.$refs.rutan.querySelector('[autofocus]');
									//afEl && afEl.focus();
									////afEl && afEl.select();	// Även select. Eller?
								}
							}
							, 200	// ms
						);
					}
					, this	// Vue.nextTick 'this' context.
				);

			});
		},

		inaktiveraMenynOmDenArAktiverad() {
			// Obs! Denna måste palla att anropas även om menyn *inte* är aktiverad:
			//console.log('inaktiveraMenynOmDenArAktiverad', `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			if (this.arAktiverad)
			{
				//console.log('   +---> den är aktiverad');

				this.stoppaEventLyssningForPilningIMenyn();
				this.stoppaEventLyssningForStangningAvMenyn();

				this.$emit('menyn-inaktiverad');
			}

			this.arAktiverad = false;

			document.activeElement.blur();	// Inget fokuserat.

			//console.log('   +---> done:', `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);
		},

		//initieraMenyn() {
		//	//console.log('# initieraMenyn pop-up-meny', this.uniktId);

		//	this.vidElement = Object.freeze(document.querySelector(this.vpVidElementQuerySelector));		// Obs! Object.freeze()

		//	console.assert(//		!!this.vidElement,
		//		`Det finns inget (vid-)element som matchar query selectorn '${this.vpVidElementQuerySelector}'.`
		//	);

		//	this.sattMenynsDimOchPos();

		//	// För att elementet ska hinna visas:
		//	this.$nextTick(function () {
		//		//console.log('# initieraMenyn+NextTick pop-up-meny', this.uniktId);

		//		this.positioneraOmMenynOmDenOverflowarBody();

		//		// Eftersom ompositioneringen ovan sker reaktivt, inväntar vi här nextTick *ännu* en gg innan event-lyssningen startas:
		//		// Huvudanledning: scroll-event kan ibland erhållas *utan* att användaren scrollat, ex om man öppnar en meny som initialt, innan den hunnit positioneras om, overflowar nederkanten av skärmen. Vi vill *inte* fånga ett sådant "ghost-scroll-event" i vår hantering för att stänga menyn/annat!

		//		// Fick inte att funka. Funkar när jag debuggar och pausar i DevTools, men inte utan. Slutsats: nextTickarna körs innan *skärmen* uppdaterats, men efter att Vue manipulerat DOM:en som webbläsaren senare ska uppdatera på skärmen. Det vi vill är att invänta *skärmuppdateringen* istället (se ny kod nedan):
		//		// "nextTick allows you to do something after you have changed the data and VueJS has updated the DOM based on your data change, but before the browser has rendered those changed on the page":
		//		//
		//		//// Ehh.. av ngn anledning var jag tvungen att vänta FLERA ticks här. Kanske för att jag gör en nextTick inuti en nextTick????:
		//		//// DOM not updated yet
		//		//Vue.nextTick(function () {
		//		//		Vue.nextTick(function () {
		//		//				Vue.nextTick(function () {
		//		//						// DOM updated:
		//		//						// "nextTick allows you to do something after you have changed the data and VueJS has updated the DOM based on your data change, but before the browser has rendered those changed on the page":
		//		//						this.startaEventLyssningForStangningAvMenyn();

		//		//						// Fokusera menyn så att tangenttrycksevents kan hanteras och tabbning startar på rätt ställe:
		//		//						this.$refs.menyn.focus();
		//		//					}
		//		//					, this	// Vue.nextTick 'this' context.
		//		//				);

		//		//			}
		//		//			, this	// Vue.nextTick 'this' context.
		//		//		);

		//		//	}
		//		//	, this	// Vue.nextTick 'this' context.
		//		//);


		//		// 1. Invänta att den eventuella ompositioneringen ovan reaktivt slagit igenom i DOM (men innan webbläsaren renderat om skärmen):
		//		// DOM not updated yet
		//		Vue.nextTick(function () {
		//				// DOM updated:
		//				// "nextTick allows you to do something after you have changed the data and VueJS has updated the DOM based on your data change, but before the browser has rendered those changed on the page":

		//				// 2: Invänta att webbläsaren även uppdaterat skärmen:

		//				// Grrrr!!! Funkade INTE: Ersatt med RÅ och OTILLFÖRLITLIG och KORKAD timeout istället:
		//				//// https://www.freecodecamp.org/forum/t/how-to-make-js-wait-until-dom-is-updated/122067/2:
		//				//// Several years ago there was an answer on Stackoverflow that said you could use setTimeout with a timeout of 0. That seemed to work in all the major browsers then, but it no longer works in Firefox 62. Now setTimeout only works if the timeout is long enough, where “long enough” is likely to vary from system to system and platform to platform.
		//				//// I recently did some experimenting to try alternatives. What seems to work in all the major browsers that I can test (Firefox, Chrome, Safari, Edge, and mobile Safari) is double requestAnimationFrame.
		//				////function call_after_DOM_updated(fn)
		//				////{
		//				////	 intermediate = function () {window.requestAnimationFrame(fn)}
		//				////	 window.requestAnimationFrame(intermediate)
		//				////}

		//				//// Schedule the function to run at the start of the frame:
		//				//let that = this;
		//				//window.requestAnimationFrame(function () {
		//				//	window.requestAnimationFrame(function () {
		//				//		that.startaEventLyssningForStangningAvMenyn();

		//				//		// Fokusera menyn så att tangenttrycksevents kan hanteras och tabbning startar på rätt ställe:
		//				//		that.$refs.menyn.focus();
		//				//	});
		//				//});

		//				// Här testar jag att lösa this-problemet på lite "moderna" sätt, med bind(), enl https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout#Possible_solutions:
		//				//let that = this;
		//				setTimeout((function() {
		//						this.startaEventLyssningForPilningOchEscIMenyn();
		//						this.startaEventLyssningForStangningAvMenyn();

		//						this.menynArAktiv = true;

		//						// Utgått i och med maintain-tab-focus:
		//						//// Fokusera menyn så att tangenttrycksevents kan hanteras och tabbning startar på rätt ställe:
		//						//this.$refs.menyn.focus();
		//					})
		//					.bind(this)	// bind() definierar vad 'this' ska bindas till inne i funktionen.
		//					, 200	// ms
		//				);
		//			}
		//			, this	// Vue.nextTick 'this' context.
		//		);

		//	});
		//},

		//avinitieraMenynOmDenArInitierad() {
		//	//console.log('# avinitieraMenyn pop-up-meny', this.uniktId);

		//	// Obs! Dessa måste palla att anropas även om menyn *inte* är aktiverad:

		//	this.stoppaEventLyssningForPilningIMenyn();
		//	this.stoppaEventLyssningForStangningAvMenyn();

		//	this.menynArAktiv = false;

		//	document.activeElement.blur();	// Inget fokuserat.

		//},

		sattMenynsDimOchPos() {
			// Aktuell (!) skärmposition på elementet som menyn ska ansluta till (ex en mermeny-burgare):
			let vidElRect = this.vidElement.getBoundingClientRect();

			//console.log('sattMenynsDimOchPos', vidElRect, `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Obs! Här kan vi inte med lätthet avläsa menyn bred/höjd, då den ännu inte renderats. Moment 22!
			// Strategin för att positionero om om den overflowar body blir istället att först rendera den overflowad och sedan flytta in den vid behov. Se positioneraOmMenynOmDenOverflowarBody().

			switch (this.vpPlacering)
			{
				case 'u':	// Under vid-elementet
				{
					this.menynsDimOchPos.x = vidElRect.x;
					this.menynsDimOchPos.y = vidElRect.y + vidElRect.height + 5;
					break;
				}

				case 'h':	// Till höger om vid-elementet
				{
					this.menynsDimOchPos.x = vidElRect.x + vidElRect.width - 5;
					this.menynsDimOchPos.y = vidElRect.y;
					break;
				}

				default:
				{
					const feltext = `Felaktig placerings-kod för pop-up-meny: '${this.vpPlacering}'.`;
					throw new Error(feltext);
				}
			}

			// Dessa sätts ev om senare av positioneraOmMenynOmDenOverflowarBody():
			this.menynsDimOchPos.width = 'auto';
			this.menynsDimOchPos.height = 'auto';
		},

		positioneraOmMenynOmDenOverflowarBody() {
			//console.log('positioneraOmMenynOmDenOverflowarBody', this.$refs.menyn, `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Obs! När denna anropas *måste* elementet vara renderat (så att .offset* kan avläsas)!

			// Obs! Eftersom logiken nedan även kan ändra höjd/bredd, så kan den ge upphov till *nytt* overflow. Exempel:
			// Menyn flyttas uppåt för att den overflowar nederkanten. Dess bredd ändras också för utrymmet är mindre än menybredden. Då dyker en horisintell rullningslist upp som i sig *ökar höjden*. Denna nya höjd har man därmed inte tagit höjd för så den hamnar nedanför skärmen (förutom de initiala 5 px (extraMargTillKanten = 5)).
			// Motsvarande kan uppstå i den andra dimensionen, om höjden är liten.
			// Detta är ett så ytte-pytte-litet problem, så det skiter vi i.
			// ..fast på prov ökar jag extraMargTillKanten och det verkade göra susen (och blir dessutom snyggare!).

			let bodyElWidth = document.body.offsetWidth;
			let bodyElHeight = document.body.offsetHeight;

			let menynsLeft = this.$refs.menyn.offsetLeft;
			let menynsTop = this.$refs.menyn.offsetTop;
			let menynsWidth = this.$refs.menyn.offsetWidth;
			let menynsHeight = this.$refs.menyn.offsetHeight;

			let extraMargTillKanten = 25;

			let nyLeft = Math.min(menynsLeft, bodyElWidth - menynsWidth - extraMargTillKanten);
			let nyTop = Math.min(menynsTop, bodyElHeight - menynsHeight - extraMargTillKanten);

			let nyWidth = menynsWidth;
			let nyHeight = menynsHeight;

			// Kolla om den kommit utanför i andra änden:

			if (nyLeft < extraMargTillKanten)
			{
				// Putta in genom att ändra bredden (och positionen):
				nyWidth -= ((-nyLeft) + extraMargTillKanten);
				nyLeft = extraMargTillKanten;
			}

			if (nyTop < extraMargTillKanten)
			{
				// Putta in genom att ändra höjden (och positionen):
				nyHeight -= ((-nyTop) + extraMargTillKanten);
				nyTop = extraMargTillKanten;
			}

			// Uppdatera style vid behov:
			if (nyLeft !== menynsLeft
				|| nyTop !== menynsTop
			)
			{
				this.menynsDimOchPos.x = nyLeft;
				this.menynsDimOchPos.y = nyTop;
			}

			// Bredd/höjd kollas i separata villkor eftersom dessa i utgångsläget inte är satta (endast min/max) och vi bara vill sätta dem om det verkligen behövs:
			if (nyWidth !== menynsWidth)
			{
				this.menynsDimOchPos.width = nyWidth + 'px';	// Obs! Denna *inkl* enhet (pga att den initialt sätts till 'auto')!
			}

			if (nyHeight !== menynsHeight)
			{
				this.menynsDimOchPos.height = nyHeight + 'px';	// Obs! Denna *inkl* enhet (pga att den initialt sätts till 'auto')!
			}

			this.arSlutpositionerad = true;

			// Tooltips måste nu bindas om, för den nyskapade menyn kan innehålla sådana:
			// Todo: (görs för hela sidan och jag tror *utan* att de gamla bindningarna avvbinds! Osäker om det kan ge minnesläckor!):
			ssoTooltips.ominitiera();
		},

		inaktiveraOchStangDenOppnadeMenyn() {
			//console.log('inaktiveraOchStangDenOppnadeMenyn', `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Propen används med .sync i parent component:
			this.$emit('update:vpVisaMenyn', false);

			// Resten av avinitieringen sker reaktivt genom watch!
		},

		startaEventLyssningForPilningOchEscIMenyn() {
			//console.log('startaEventLyssningForPilningOchEscIMenyn', `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			document.addEventListener('keydown', this.onKeyDown);
		},

		stoppaEventLyssningForPilningIMenyn() {
			//console.log('stoppaEventLyssningForPilningIMenyn', `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Obs! Denna måste palla att anropas även om inga events är bundna:
			document.removeEventListener('keydown', this.onKeyDown);
		},

		startaEventLyssningForStangningAvMenyn() {
			//console.log('startaEventLyssningForStangningAvMenyn', `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Dessa event-listeners kan inte addas som anonymous arrow functions (för att hantera "this") eftersom de ska removeas senare. "There is no way to cleanly remove an event handler unless you stored a reference to the event handler at creation.":

			window.addEventListener('resize', this.onEventSomKanskeSkaStangaMenyn);

			// Lodash trottle creates a throttled function so you need to store a reference to it in order to remove the eventlistener:
			this.$_trottledEvenlistenerFunction = throttla((e) => this.onEventSomKanskeSkaStangaMenyn(e),
					100,	// Så lång throttlingstid i ms.
					{ trailing: true, leading: true }	// Setting the leading to true will begin callback execution immediately and then throttle. When you set *both* leading and trailing to true, this guarantees execution per interval.
				);
			//The simplest way to detect all scroll events in modern browser would be using 'capturing' rather than 'bubbling' when attaching the event:
			//window.addEventListener('scroll', function(){ code goes here }, true)
			window.addEventListener('scroll', this.$_trottledEvenlistenerFunction, true);			// ! capture = true

			document.addEventListener('mousedown', this.onEventSomKanskeSkaStangaMenyn, { passive: true });
			document.addEventListener('touchstart', this.onEventSomKanskeSkaStangaMenyn, { passive: true });
		},

		stoppaEventLyssningForStangningAvMenyn() {
			//console.log('stoppaEventLyssningForStangningAvMenyn', `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Obs! Denna måste palla att anropas även om inga events är bundna:

			//let that = this;
			// window.addEventListener('keydown', function(e) {return that.someMethod(e);});
			// Går inte, för den måste tas bort med SAMMA metod som den skapades: document.removeEventListener('keydown', (e) => that.inaktiveraOchStangDenOppnadeMenyn(e));

			window.removeEventListener('resize', this.onEventSomKanskeSkaStangaMenyn);

			if (this.$_trottledEvenlistenerFunction)
			{
				// Bara om sådant event är bundet:
				window.removeEventListener('scroll', this.$_trottledEvenlistenerFunction, true);			// ! capture = true
				this.$_trottledEvenlistenerFunction = undefined;
			}

			document.removeEventListener('mousedown', this.onEventSomKanskeSkaStangaMenyn);
			document.removeEventListener('touchstart', this.onEventSomKanskeSkaStangaMenyn);
		},

		onKeyDown(e) {
			//console.log('onKeyDown', e, `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			if (e.defaultPrevented) {
				return; // Do nothing if the event was already processed
			}

			//console.log(`Tangent: key="${e.key}", keycode=${e.keyCode}, key.charCodeAt(0)=${e.key.charCodeAt(0)}`);

			if (e.key == 'Escape'
				|| (this.vpArUndermeny && e.key == 'ArrowLeft')
			)
			{
				this.inaktiveraOchStangDenOppnadeMenyn();	// = Avbryt

				// Cancel the default action to avoid it being handled twice
				event.preventDefault();
				return;
			}

			//if (this.vpArUndermeny
			//	&& e.key == 'ArrowLeft'
			//)
			//{
			//}

			if (e.key == 'ArrowDown'
				|| e.key == 'ArrowRight'
				|| e.key == 'ArrowUp'
				|| e.key == 'ArrowLeft'
			)
			{
				// Hantera pilarna "som Tab/Bakåttab" inom menyn:
				// Dock ska Right/Left hanteras som öppna/stäng undermeny om alternativet med fokus är ett sådant. Av anledningar som jag inte vill gå in på (det funkade så, men inte på andra testade sätt) så hanteras ArrowRight med en @keydown.Right... medan ArrowLeft hanteras i egna eventhanteraren, ovan.





// Todo: %%%%%%%%%%%%%%%%%%%%%%%%%%%%%Tabba till nästa alt brytas ut som metod. Anropa den även i NextTick efter pil höger öppna undermeny!




				// Sekvensen hämtas för varje piltryck, för att hantera ev ändrade förhållanden:
				let tabSequence = allyQuery.tabsequence({
					context: this.$refs.menyalternativContainer,	//'.within-filter-selector',   Skulle kunna kört med default (document) för vid det här laget är tabbningen begränsad.
					includeContext: false,
					includeOnlyTabbable: false,
					strategy: 'quick',
				});

				//console.log('tabSequence', tabSequence);

				let activeEl = document.activeElement;
				//let activeElNodeName = activeEl.nodeName;
				let activeElMenydelIndex = activeEl.getAttribute('menydel-index');	//.id;

				// -1 = inget av alt (som är ett menyalt(!), fler tabbable kan finnas i ex.vis tabellhuvudet!) i tabsekvensen är aktivt:
				let activeTabSequenceIndex = tabSequence.map(function(alt) { return alt.getAttribute('menydel-index'); }).indexOf(activeElMenydelIndex);


				//console.log('activeIndexInTabSequence', activeIndexInTabSequence);

				if (e.key == 'ArrowDown'
					|| e.key == 'ArrowRight'
				)
				{
					// Emulera Tab:

					if (activeTabSequenceIndex === -1
						|| activeTabSequenceIndex === tabSequence.length - 1
					)
					{
						// Inget av alt i tabsekvensen är aktivt
						// ELLER det sista alt är aktivt:
						// "Tabba" till första:
						tabSequence[0].focus();
					}
					else
					{
						// Annars, tabba till nästa:
						tabSequence[activeTabSequenceIndex + 1].focus();
					}

					// Cancel the default action to avoid it being handled twice
					event.preventDefault();
					return;
				}


				if (e.key == 'ArrowUp'
					|| e.key == 'ArrowLeft'
				)
				{
					// Emulera Bakåttab:

					if (activeTabSequenceIndex === -1
						|| activeTabSequenceIndex === 0
					)
					{
						// Inget av alt i tabsekvensen är aktivt
						// ELLER det första alt är aktivt:
						// "Bakåttabba" till sista:
						tabSequence[tabSequence.length - 1].focus();
					}
					else
					{
						// Annars, bakåttabba till föreg:
						tabSequence[activeTabSequenceIndex - 1].focus();
					}

					// Cancel the default action to avoid it being handled twice
					event.preventDefault();
					return;
				}
			}
		},

		onEventSomKanskeSkaStangaMenyn(e) {
			//console.log('onEventSomKanskeSkaStangaMenyn', e, `[${this.uniktIdNr}]`, `${(this.visaMenyn ? 'visas' : '     ')} ${(this.arOverstaMenyn ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Obs! Denna används för *flera olika* events!

			// Kolla om det är ett event som *inte* ska stänga menyn:

			//if (e.type == 'scroll' || e.type == 'resize')
			//{
			//	return;
			//}

			if (e.type == 'scroll')
			{
				if (e.target === this.$refs.menyn
					|| this.$refs.menyn.contains(e.target)
				)
				{
					// Om man scrollat själva menyelementet
					// ELLER något element i menyelementet (ancestor):
					// Stäng *inte* menyn:
					return;
				}
			}

			if (e.type == 'mousedown' || e.type == 'touchstart')
			{
				if (e.target === this.$refs.menyn
					|| this.$refs.menyn.contains(e.target)
				)
				{
					// Om man klickat på själva menyelementet
					// ELLER något element i menyelementet (ancestor):
					// Stäng *inte* menyn:
					return;
				}

				// Kolla på samma sätt som ovan även om det finns något utvald element på vilket klick/touch också ska undantas:
				if (this.vpStangInteVidKlickTouchPaVidElementet
					&& e.target === this.vidElement
					|| this.vidElement.contains(e.target)
				)
				{
					return;
				}
			}

			// Unable to preventDefault inside passive event listener invocation:
			//// Cancel the default action to avoid it being handled twice
			//event.preventDefault();

			this.inaktiveraOchStangDenOppnadeMenyn();	// = Avbryt
		},


		// ==============================================================================================================

		onMouseOverMenyalternativ(menydelIndex) {
			//console.log('onMouseOverMenyalternativ', `[${this.uniktIdNr}]`, `${this.mouseIsOverMenydelIndex} –> ${menydelIndex}`);

			// Sätt först om mouseIsOverMenydelIndex:
			this.mouseIsOverMenydelIndex = menydelIndex;

			// Vidta action:
			const alt = this.menyConfig.menydelar[menydelIndex];

			switch (alt.typ)
			{
				case euiPopUpMenyClasses.delTypEnum.UNDERMENY:
					{
						this.oppnaUndermenyEfterFordrojning(this, menydelIndex);
						break;
					}

				case euiPopUpMenyClasses.delTypEnum.EVENT:
				case euiPopUpMenyClasses.delTypEnum.LANK:
					{
						this.stangAllaUndermenyerEfterFordrojning(this, menydelIndex);
						break;
					}
			}
		},

		onMouseLeaveMenyalternativ(menydelIndex) {
			//console.log('onMouseLeaveMenyalternativ', `[${this.uniktIdNr}]`, `Old: ${this.mouseIsOverMenydelIndex}`);


			// Sätt först om mouseIsOverMenydelIndex:
			if (this.mouseIsOverMenydelIndex === menydelIndex)
			{
				// Om ingen ny menydel redan är satt:
				//console.log('onMouseLeaveMenyalternativ', `[${this.uniktIdNr}]`, `${this.mouseIsOverMenydelIndex} –> ${undefined}`);

				this.mouseIsOverMenydelIndex = undefined;
			}

			// Vidta action:
			const alt = this.menyConfig.menydelar[menydelIndex];

			switch (alt.typ)
			{
				case euiPopUpMenyClasses.delTypEnum.UNDERMENY:
					{
						this.stangUndermenyEfterFordrojning(this, menydelIndex);
						break;
					}

				//case euiPopUpMenyClasses.delTypEnum.EVENT:
				//case euiPopUpMenyClasses.delTypEnum.LANK:
				//	{
				//		break;
				//	}
			}
		},


		// ===============================================================================================================

		oppnaUndermenyEfterFordrojning: debounce((that, menydelIndex) => {
				// Debounce (https://lodash.com/docs#debounce):
				//Arguments
				//func (Function): The function to debounce.
				//[wait=0] (number): The number of milliseconds to delay.
				//[options={}] (Object): The options object.
				//[options.leading=false] (boolean): Specify invoking on the leading edge of the timeout.
				//[options.maxWait] (number): The maximum time func is allowed to be delayed before it's invoked.
				//[options.trailing=true] (boolean): Specify invoking on the trailing edge of the timeout.

				// Obs! Denna anv *endast* vid mushovring (inte tangentbordsnavigering)!

				const alt = that.menyConfig.menydelar[menydelIndex];

				if (!alt.visaUndermenyn)
				{
					// Bara om undermenyn inte redan visas (pga att upprepade mouseover/-leave events kan inträffa, samt man kan ev även trigga denna med tangentbordet):

					//console.log('oppnaUndermenyEfterFordrojning', `[${that.uniktIdNr}]`, menydelIndex, `mouseIsOverMenydelIndex: ${that.mouseIsOverMenydelIndex}`);

					if (that.mouseIsOverMenydelIndex !== undefined && that.mouseIsOverMenydelIndex === menydelIndex)
					{
						// Om musen *fortfarande* är över den menydel som triggade:
						//console.log('   +---> Musen är *forf* över den menydel som triggade.');

						that.oppnaUndermeny(menydelIndex);
					}
				}
			},

			300,	// Så lång debouncetid i ms.
			{
				leading: false,  	// Setting the leading to true will begin callback execution immediately and then throttle. When you set *both* leading and trailing to true, this guarantees execution per interval.
				trailing: true,
				maxWait: 300,
			}
		),

		stangUndermenyEfterFordrojning: debounce((that, menydelIndex) => {
				// Debounce (https://lodash.com/docs#debounce):
				//Arguments
				//func (Function): The function to debounce.
				//[wait=0] (number): The number of milliseconds to delay.
				//[options={}] (Object): The options object.
				//[options.leading=false] (boolean): Specify invoking on the leading edge of the timeout.
				//[options.maxWait] (number): The maximum time func is allowed to be delayed before it's invoked.
				//[options.trailing=true] (boolean): Specify invoking on the trailing edge of the timeout.

				// Obs! Denna anv *endast* vid mushovring (inte tangentbordsnavigering)!

				const alt = that.menyConfig.menydelar[menydelIndex];

				if (alt.visaUndermenyn)
				{
					// Bara om undermenyn fortf visas (pga att upprepade mouseover/-leave events kan inträffa, samt man kan ev även trigga denna med tangentbordet):

					//console.log('stangUndermenyEfterFordrojning', `[${that.uniktIdNr}]`, menydelIndex, `mouseIsOverMenydelIndex: ${that.mouseIsOverMenydelIndex}`);

					if (that.mouseIsOverMenydelIndex === undefined || that.mouseIsOverMenydelIndex !== menydelIndex)
					{
						// Om musen fortfarande *inte* är över den menydelen som triggade:
						//console.log('   +---> Musen är forf *inte* över den menydel som triggade.');

						that.stangUndermeny(menydelIndex);
					}
				}
			},

			300,	// Så lång debouncetid i ms.
			{
				leading: false,  	// Setting the leading to true will begin callback execution immediately and then throttle. When you set *both* leading and trailing to true, this guarantees execution per interval.
				trailing: true,
				maxWait: 300,
			}
		),

		stangAllaUndermenyerEfterFordrojning: debounce((that, menydelIndex) => {
				// Debounce (https://lodash.com/docs#debounce):
				//Arguments
				//func (Function): The function to debounce.
				//[wait=0] (number): The number of milliseconds to delay.
				//[options={}] (Object): The options object.
				//[options.leading=false] (boolean): Specify invoking on the leading edge of the timeout.
				//[options.maxWait] (number): The maximum time func is allowed to be delayed before it's invoked.
				//[options.trailing=true] (boolean): Specify invoking on the trailing edge of the timeout.

				//console.log('stangAllaUndermenyerEfterFordrojning', `[${that.uniktIdNr}]`, menydelIndex, `mouseIsOverMenydelIndex: ${that.mouseIsOverMenydelIndex}`);

				that.stangAllaUndermenyer(menydelIndex);
			},

			300,	// Så lång debouncetid i ms.
			{
				leading: false,  	// Setting the leading to true will begin callback execution immediately and then throttle. When you set *both* leading and trailing to true, this guarantees execution per interval.
				trailing: true,
				maxWait: 300,
			}
		),


		// ===============================================================================================================

		oppnaUndermeny(menydelIndex) {
			const alt = this.menyConfig.menydelar[menydelIndex];

			if (!alt.visaUndermenyn)
			{
				// Bara om undermenyn inte redan visas (pga att upprepade mouseover/-leave events kan inträffa, samt man kan ev även trigga denna med tangentbordet):

				//console.log(`##### Öppna undermeny med ix ${menydelIndex}.`, `[${this.uniktIdNr}]`);

				//alt.visaUndermenyn = true;

				//this.menyConfig.visaUndermenynForMenydelOchStangEvAndra(menydelIndex);

				let nyMenyConfig = new euiPopUpMenyClasses.menyConfig([]);		// [] här för parameterkontrollen (obligatorisk) ovan.
				nyMenyConfig = Object.assign(nyMenyConfig, this.menyConfig);

				// Todo: Grr... något går snett när man stänger en och öppnar en annan i samma svep (samma 'update:vpMenyConfig'-event, antagligen). Då skapas ibland ingen ny popupmeny-komponent för den nya undermenyn utan den gamla komponenten, den för undermenyn som stängs, *återanvänds*! Gissar att det beror på att saker (reaktivitet) "sker i fel ordning".
				// Provar att istället dela upp stängning och öppning i 2 'update:vpMenyConfig'-events:
				//nyMenyConfig.visaUndermenynForMenydelOchStangEvAndra(menydelIndex);
				// Funkade inte heller!
				// Se även: https://vuejs.org/v2/guide/reactivity.html#Async-Update-Queue
				// Provar att även invänta nästa tick innan det andra eventet emittas:
				// That did the trick!

				nyMenyConfig.stangAllaUndermenyer();

				// Propen används med .sync i parent component:
				this.$emit('update:vpMenyConfig', nyMenyConfig);

				this.$nextTick(function () {
					nyMenyConfig.visaUndermenynForMenydelOchStangEvAndra(menydelIndex);

					// Propen används med .sync i parent component:
					this.$emit('update:vpMenyConfig', nyMenyConfig);
				});
			}
		},

		stangUndermeny(menydelIndex) {
			const alt = this.menyConfig.menydelar[menydelIndex];

			if (alt.visaUndermenyn)
			{
				// Bara om undermenyn fortf visas (pga att upprepade mouseover/-leave events kan inträffa, samt man kan ev även trigga denna med tangentbordet):

				let undermenyEl = this.$refs['undermeny-till-' + menydelIndex][0];

				if (!undermenyEl || !undermenyEl.mouseIsOverMeny)
				{
					// Bara om man *inte* hovrar över själva undermenyn f.n:

					//console.log(`##### Stäng undermeny med ix ${menydelIndex}.`, `[${this.uniktIdNr}]`);

					//alt.visaUndermenyn = false;

					let nyMenyConfig = new euiPopUpMenyClasses.menyConfig([]);		// [] här för parameterkontrollen (obligatorisk) ovan.
					nyMenyConfig = Object.assign(nyMenyConfig, this.menyConfig);

					nyMenyConfig.stangUndermenynForMenydel(menydelIndex);

					// Propen används med .sync i parent component:
					this.$emit('update:vpMenyConfig', nyMenyConfig);
				}
			}
		},

		stangAllaUndermenyer(menydelIndex) {

			if (menydelIndex === this.mouseIsOverMenydelIndex)
			{
				// Bara om musen fortfarande är över den menydel som triggade:

				//console.log(`##### Stäng alla undermenyer.`, `[${this.uniktIdNr}]`);

				let nyMenyConfig = new euiPopUpMenyClasses.menyConfig([]);		// [] här för parameterkontrollen (obligatorisk) ovan.
				nyMenyConfig = Object.assign(nyMenyConfig, this.menyConfig);

				nyMenyConfig.stangAllaUndermenyer();

				// Propen används med .sync i parent component:
				this.$emit('update:vpMenyConfig', nyMenyConfig);
			}
		},

		onMenyalternativValtIUndermeny({ eventId, eventData }) {

			this.inaktiveraOchStangDenOppnadeMenyn();

			// Emitta uppåt en nivå i meny/undermeny-hierarkin:
			this.$emit('menyalternativ-valt-i-pop-up-meny',
				// Payload:
				{ eventId: eventId, eventData: eventData }
			);
		},


		//==================================================================================================================

		onMenyalternativValt(menydelIndex) {

			//if ((alt.behallOppenVidVal || false) === false)
			//{
			//	this.inaktiveraOchStangDenOppnadeMenyn();
			//}
			//else
			//{
			//	this.avinitieraMenynOmDenArInitierad();
			//}

			this.inaktiveraOchStangDenOppnadeMenyn();

			// js-variant of linq firstOrDefault():https://gist.github.com/DanDiplo/30528387da41332ff22b:
			//let alt = this.menyConfig.menydelar.filter(function (alt) { return alt.id === id; })[0] || null;
			let alt = this.menyConfig.menydelar[menydelIndex];

			switch (alt.typ)
			{
				case euiPopUpMenyClasses.delTypEnum.LANK:
					{
						// Om direkt länkning ska ske:

						// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
						this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

						if (alt.nyttFonster) {
							var strWindowFeatures = 'location=yes,height=2800,width=1550,scrollbars=yes,status=yes';
							window.open(alt.lank, '_blank', strWindowFeatures);
						}
						else {
							window.location.href = alt.lank;
						}
						break;
					}

				case euiPopUpMenyClasses.delTypEnum.EVENT:
					{
						// Om ett event emittas:
						this.$emit('menyalternativ-valt-i-pop-up-meny',
							// Payload:
							{ eventId: alt.eventId, eventData: alt.eventData }
						);

						break;
					}
			}
		},
	},



	//== Lifecycle hooks  ================================================================================================================

	beforeCreate() {
		// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.
		//console.log('beforeCreate: pop-up-meny', this.uniktId);

		// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
		// Exempel: this.$_undertryckNastaAndradEvent = false;

		this.$_trottledEvenlistenerFunction = undefined;
	},

	created()
	{
		// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.

		// https://medium.com/@brockreece/vue-parent-and-child-lifecycle-hooks-5d6236bd561f
		// A component becomes reactive just before the Created hook is fired, this means it will start to track changes of it’s props before it’s parent’s Mounted hook has fired. This is worth remembering if you have logic setting the value of a prop in the parent’s Mounted hooks.
		// The example below shows the difference between preparing your prop data in both the Created and Mounted hooks of the parent component. As you can see, the prop that was set in the Mounted hook reacts twice on the child component.
		// ...
		// Imagine if your child component made an Ajax request every time this prop changes, this would cause twice as much network activity and this could easily respond out of order.
		// As a quick rule of thumb, I suggest only using the Mounted hook if your component needs to interact with the DOM, anything else should probably be taken care of in the Created hook.

		//console.log('created: pop-up-meny', this.vpVisaMenyn, this.visaMenyn, this.uniktId);


		this.vidElement = document.querySelector(this.vpVidElementQuerySelector);

		console.assert(!!this.vidElement,
			`Det finns inget (vid-)element som matchar query selectorn '${this.vpVidElementQuerySelector}'.`
		);


		// Skapa portal-target-elementet för <portal... och lägg till i DOM:

		// Lägg till vanligt html-element som ska användas som portal-target:
		// Obs! Måste ligga utanför appen, för att inte skrivas över och försvinna när appen mountas/updateas!
		let el = document.createElement('div');
		//el.classList.add('_portal-target');
		el.setAttribute('id', this.portalTargetName);
		document.body.insertAdjacentElement('beforeend', el);	// 'beforeend': Just inside the targetElement, after its last child. För att nestade undermenyer ska hamna över sin "parent" (syskon som ligger tidigare i html-sekvens).

		//// Todo: Detta är TMP för TMP test av pop-up-meny som är öppen från start:
		//// Om vid-element propen saknas, sätt fejkat el:
		//if (!this.vidElement)
		//{
		//	this.vidElement = document.body.querySelector('div.bounce');
		//}
	},

	//beforeMount()
	//{
	//	// Called right before the mounting begins: the render function is about to be called for the first time.
	//	// This hook is not called during server-side rendering.
	//	// Detta är hooken efter att Vues kompilering är klar. v-cloak är fortfarande kvar, men plockas bort strax efter denna körts.
	//	// Här är det inte lämpligt att förändra DOM, för den ersätts vid den stundande renderingen och då tappas ändringarna (är jag ganska säker på).
	//	//console.log('beforeMount: pop-up-meny', this.vpVisaMenyn, this.visaMenyn, this.uniktId);
	//},

	mounted() {
		// Note that mounted does not guarantee that all child components have also been mounted.
		//-----------------------------------------------------------------------------------------------------------------------
		// Mixin hooks will be called *before* the component’s/app’s own hooks. Ordning:
		//
		// 1. Mixins mounted hook.
		// 2. Appens/komponentens mounted hook.
		//
		// 3. Mixins mounted hook + nextTick (DOM not updated yet).
		// 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet).
		//
		// 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		// 6. Appens/komponentens mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		//
		// Det är *först efter steg 4* ovan som allt är färdigrenderat, med avseende på Vue-grejs som exempelvis all reaktivitet som förekommer i appen (ex visa/dölj element)!
		//
		// Alltså, saker som ska göras i denna mixins mounted och som ska ske *efter* steg 2 ovan:
		// a) kan göras som steg 3 ovan, *om* det *inte* är beroende av att allt reaktivt är garanterat färdigrenderat eller
		// b) måste göras som steg 5 ovan, *om* det är beroende av att allt reaktivt är garanterat färdigrenderat.
		//-----------------------------------------------------------------------------------------------------------------------
		//console.log('mounted: pop-up-meny', this.vpVisaMenyn, this.visaMenyn, this.uniktId);

		//## 2. Appens/komponentens mounted hook:  #################################
		//console.log('2. Appens/komponentens mounted hook');

		this.$nextTick(function () {
			// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
			// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

			//## 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet):  #################################
			//console.log('4. Appens/komponentens mounted hook + nextTick');

			//console.log('mounted+NextTick: pop-up-meny', this.vpVisaMenyn, this.visaMenyn, this.uniktId);

			// FÖRST NU initieras visningen *om* den är satt via vpVisaMenyn att den ska visas initialt:
			this.visaMenyn = this.vpVisaMenyn;
			// Resten av initieringen sker reaktivt genom watch!
		});
	},

	//beforeUpdate()
	//{
	//	// Called when data changes, before the DOM is patched. This is a good place to access the existing DOM before an update, e.g. to remove manually added event listeners.
	//	// This hook is not called during server-side rendering, because only the initial render is performed server-side.
	//	// Obs! Det är ganska lätt att hamna i ett läge där denna anropas multipla ggr, dvs man ändrar flera responsiva saker och då triggas denna 1 gg för varje (?), typ!
	//	// Obs! "The lifecycle hooks around update respond to changes in the DOM. Watchers respond to changes in the data. DOM changes are generally in response to data changes, but they might not be data owned by the component in question."
	//	//console.log('beforeUpdate: pop-up-meny', this.vpVisaMenyn, this.visaMenyn, this.uniktId);
	//},

	//updated()
	//{
	//	// Called after a data change causes the virtual DOM to be re-rendered and patched.
	//	// The component’s DOM will have been updated when this hook is called, so you can perform DOM-dependent operations here. However, in most cases you should avoid changing state inside the hook. To react to state changes, it’s usually better to use a computed property or watcher instead.
	//	// This hook is not called during server-side rendering.
	//	// Note that updated does not guarantee that all child components have also been re-rendered.
	//	// Denna hook körs även efter mounted!
	//	// Obs! Det är ganska lätt att hamna i ett läge där denna anropas multipla ggr, dvs man ändrar flera responsiva saker och då triggas denna 1 gg för varje (?), typ!
	//	// Obs! "The lifecycle hooks around update respond to changes in the DOM. Watchers respond to changes in the data. DOM changes are generally in response to data changes, but they might not be data owned by the component in question."
	//	//console.log('updated: pop-up-meny', this.vpVisaMenyn, this.visaMenyn, this.uniktId);


	//	// ----------------------------------------------------------------------

	//	//this.$nextTick(function () {
	//	//	// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
	//	//	// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:
	//	//});
	//},

	//activated()
	//{
	//	// Called when a *kept-alive* component is activated.
	//	// This hook is not called during server-side rendering.
	//},

	//deactivated()
	//{
	//	// Called when a *kept-alive* component is deactivated.
	//	// This hook is not called during server-side rendering.
	//},

	beforeDestroy()
	{
		// Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
		// This hook is not called during server-side rendering.
		//console.log('beforeDestroy: pop-up-meny', this.vpVisaMenyn, this.visaMenyn, this.uniktId);

		// ?? Måste nog även göra en spådan här, så att prop-värdet i ovanliggande verkligen sätts till false (se resonemnagen nedan)????
		// Propen används med .sync i parent component:
		this.$emit('update:vpVisaMenyn', false);

		// För den eventualitet att denna komponent hinner destroyas *innan* den via reaktivitet hinner inaktivera sig själv. Det spelar mindre roll för saker som bara berör denna komponent, som alltså inte finns längre, men om det ex.vis gäller event-bindningarna till window/document (utanför denna komponent) så får de *absolut* inne ligga kvar när komponenten är destoryad!
		// Därav denna hantering här + att jag för säkerhets skull gjort event-bortbindningen så att den pallar att göras även då inga event är bundna:
		this.inaktiveraMenynOmDenArAktiverad();

		// Detta nedan låg tidigare i watch:visaMenyen, men...
		// watch:visaMenyen *och inte heller* watch:vpVisaMenyn hinner aldrig triggas när en undermenys visning sätts = false. Då destroyas den direkt. Detta skiljer sig från dialog-komponenten och anledningen är att de båsa har olika v-if-konstruktioner. Här flyttar vi därför detta till beforeDestroy():
		// Skicka detta event *här*, för inte säkert att det kan skickas senare i reaktivitetssekvensen om hela komponenten hinner detroyas innan (hade nog också kunnat ligga i beforeDestroy()?):
		// Därför har också detta event namnet "..stangs" och inte "..stangd", men när det emittas så är det oåterkalleligt så att menyn kommer att vara stängd inom båkdelar av en sekund:
		this.$emit('menyn-stangs', this.menyId);	// Egensatt Id (via prop) eller auto uppbyggt med uniktIdNr.

		this.taBortFranMenystacken();
	},

	destroyed()
	{
		// Called after a Vue instance has been destroyed. When this hook is called, all directives of the Vue instance have been unbound, all event listeners have been removed, and all child Vue instances have also been destroyed.
		// This hook is not called during server-side rendering.
		//console.log('destroyed: pop-up-meny', this.vpVisaMenyn, this.visaMenyn, this.uniktId);

		// Ta bort portal-target-elementet från DOM (om det ligger kvar):
		let el = document.getElementById(this.portalTargetName);
		if (el)
			el.remove();

		//// Completely destroy a vm. Clean up its connections with other existing vms, unbind all its directives, turn off all event listeners.
		//// Triggers the beforeDestroy and destroyed hooks.
		//// In normal use cases you shouldn’t have to call this method yourself. Prefer controlling the lifecycle of child components in a data-driven fashion using v-if and v-for.
		//this.$_portalTargetInstance.$destroy();
		//this.$_portalTargetInstance = undefined;

		// Tooltips måste nu bindas om, för den borttagna menyn kan ha innehållit sådana:
		// Todo: (görs för hela sidan och jag tror *utan* att de gamla bindningarna avvbinds! Osäker om det kan ge minnesläckor!):
		ssoTooltips.ominitiera();
	},
};
